<template>
  <div class="setup-content contact-info" id="step-6">
    <h3 class="color-darkblue">Return Material Authorization</h3>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label">Company Name:</label>
        </div>
        <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text"
          :options="locationArr" :disabled="disableAll">
        </v-select>
        <div class="field-error">{{ location_error_msg }}</div>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label">State/Province:</label>
        </div>
        <v-select v-model="state" id="state" name="state" data-info="Please select state" label="text" :filterable="false"
          :options="stateArr" @search="onSearchState" placeholder="Select State" class="custom-ci-auto-search">
          <template slot="no-options">
            Search State...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ state_error_msg }}</div>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label">City:</label>
        </div>
        <v-select v-model="city_id" id="city_id" name="city_id" data-info="Please select city" label="text"
          :filterable="false" :options="cityArr" @search="onSearchCity" placeholder="Select City"
          class="custom-ci-auto-search">
          <template slot="no-options">
            Search City...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ city_error_msg }}</div>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label">Street Address:</label>
        </div>
        <input type="text" id="street" v-model="street_address" class="form-control">
        <div class="field-error">{{ street_error_msg }}</div>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label">Zip/Postal Code:</label>
        </div>
        <input type="text" id="zip" v-model="zip" class="form-control">
        <div class="field-error">{{ zip_error_msg }}</div>
      </div>
      <!-- <div class="col form-group">
        <div class="example-label">
          <label class="control-label">Country:</label>
        </div>
        <input type="text" id="country" name="country" class="form-control">
      </div> -->
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label">Phone Number:</label>
        </div>
        <input type="text" id="phone_no" v-model="phone_no" class="form-control">
        <div class="field-error">{{ phone_no_error_msg }}</div>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label">If part found Non-warrantable:</label>
        </div>
        <v-select v-model="non_warrantable" name="non_warrantable" label="text" :options="['RETURN', 'SCRAP']"
          :disabled="disableAll">
        </v-select>
        <div class="field-error">{{ non_warrantable_error_msg }}</div>
      </div>
      <!-- <div class="col form-group">
        <div class="example-label">
          <label class="control-label">Select Carrier:</label>
        </div>
        <input type="text" id="carrier" name="carrier" class="form-control">
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label">Carrier Account Number:</label>
        </div>
        <input type="text" id="carrier_acc_no" name="carrier_acc_no" class="form-control">
      </div> -->
    </div>
    <div class="alert alert-warning hide w-50">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
          aria-hidden="true">&times;</span></button>
      <strong class="errormsg"></strong>
    </div>
    <div class="btn-groups mt-3">
      <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoBack('step-5')">
        <i class="fp-left-arrow" style="font-size:20px;"> </i> Previous </button>
      <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoNext('step-6')">
        Next <i class="fp-right-arrow right-icon"> </i></button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { contractMixins } from '../../mixins/contractMixins';
import { commonMixins } from '../../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

export default {
  name: "EvLocationTab",
  mixins: [commonMixins, contractMixins],
  data: () => ({
    location_id: "",
    state: "",
    city_id: "",
    street_address: "",
    zip: "",
    phone_no: "",
    non_warrantable: "",
    cityArr: [],
    stateArr: [],
    locationArr: [],
    location_error_msg: "",
    state_error_msg: "",
    city_error_msg: "",
    street_error_msg: "",
    zip_error_msg: "",
    phone_no_error_msg: "",
    non_warrantable_error_msg: "",
    disableAll: false,
  }),
  mounted() {
    var self = this;
    self.loadFieldData(['location']);
  },
  methods: {
    gotoNext: function (flag) {
      var self = this;
      // var success = self.validateLocationFields();
      // if (success) {
        self.emitDataToParent();
        self.gotoNextStepMixins(flag);
      // }
    },
    gotoBack: function (flag) {
      var self = this;
      // todo will only call the below function when all the requried fields have been filled.
      self.gotoBackStepMixins(flag);
    },
    onSearchState(search, loading) {
      var self = this;
      if (search.length > 2) {

        loading(true);
        self.searchField(loading, search, 'state', '');
      }
    },
    onSearchCity(search, loading) {

      var self = this;
      if (search.length > 2) {

        var stateId = self.state.value;
        if (stateId == "") {
          alert("please select state first");
          return;
        }

        loading(true);
        self.searchField(loading, search, 'city', '');
      }
    },
    validateLocationFields() {
      var self = this;
      var success = true;
      self.clearLocationFieldsErrorMessages()
      if (self.location_id == null || self.location_id == "") {
        self.location_error_msg = "Company Name Required";
        success = false;
      }
      if (self.state == null || self.state == "") {
        self.state_error_msg = "State Required";
        success = false;
      }
      if (self.city_id == null || self.city_id == "") {
        self.city_error_msg = "City Required";
        success = false;
      }
      if (self.street_address == null || self.street_address == "") {
        self.street_error_msg = "Street Address Required";
        success = false;
      }
      if (self.zip == null || self.zip == "") {
        self.zip_error_msg = "Zip Required";
        success = false;
      }
      if (self.phone_no == null || self.phone_no == "") {
        self.phone_no_error_msg = "Phone Number Required";
        success = false;
      }
      if (self.non_warrantable == null || self.non_warrantable == "") {
        self.non_warrantable_error_msg = "Required";
        success = false;
      }
      return success;
    },
    clearLocationFieldsErrorMessages() {
      var self = this;
      self.location_error_msg = "";
      self.state_error_msg = "";
      self.city_error_msg = "";
      self.street_error_msg = "";
      self.zip_error_msg = "";
      self.phone_no_error_msg = "";
      self.non_warrantable_error_msg = "";
    },
    emitDataToParent() {
      var self = this;
      const dataToSend = {
        location_id: self.location_id,
        state: self.state,
        city_id: self.city_id,
        street_address: self.street_address,
        zip: self.zip,
        phone_no: self.phone_no,
        non_warrantable: self.non_warrantable,
      };
      self.$emit("send-location-data-to-parent", dataToSend);
    },
    getLocationData(locationData){
      var self = this;
      self.location_id = {"value":locationData.location_id,"text":locationData.location_text};
      self.state = {"value":locationData.state_id,"text":locationData.state_text};
      self.city_id = {"value":locationData.city_id,"text":locationData.city_text};
      self.street_address = locationData.street_address;
      self.zip = locationData.zip;
      self.phone_no = locationData.phone_no;
      self.non_warrantable = locationData.non_warrantable;
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvLocationTab.vue